// TODO: [SP-10928] Cleanup hooks in this `core/hooks/queries/custom_fields` folder
// that operate on custom values - move to `core/hooks/queries/custom_values`
import { useMutation } from "@tanstack/react-query";
import { cleanupUnusedCustomValues } from "PFCore/services/admin/custom_values";
import { Id, MutationOptions } from "PFTypes";

import { useCustomValuesInvalidate } from "./use_custom_values_invalidate";

type MutationFnParams = {
  customTypeId: Id;
};

export const useCleanupUnusedCustomValues = (queryParams: MutationOptions<MutationFnParams>) => {
  const { invalidate } = useCustomValuesInvalidate();

  return useMutation({
    mutationFn: ({ customTypeId }: MutationFnParams): Promise<void> =>
      cleanupUnusedCustomValues(customTypeId),
    onSuccess: () => {
      invalidate();
    },
    ...queryParams
  });
};
